/**************************************************************************
 * Created on Wed Aug 21 2024
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http: //go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/

/***
 * 
 * 
 * We will create axios instance over here with common intercepter for each 
 * Request/Response & Error
 * 
 * Update if Required to update the interceptor
 * 
 * 
 * Expose createAsionInstance Same param as axios.create
 * 
 */

import axios, { AxiosError, AxiosInstance, AxiosResponse, CreateAxiosDefaults, InternalAxiosRequestConfig } from "axios";
import { CustomAxiosRequestConfig } from "./custom-axios";
import { fetchCSRFToken, getCSRFModule } from "../csrf-helper";
import { getMockData } from "../mock-data-services";

const requestInterceptor = async (config: CustomAxiosRequestConfig): Promise<CustomAxiosRequestConfig> =>
{

    config.headers[ "Accept" ] = "*/*";

    // Add appName header for guest users
    const isGuestUser = sessionStorage.getItem('isGuestUser') === 'true';
    if (isGuestUser) {
        config.headers[ "appName" ] = "INDS";
    }

    config.headers[ "Content-Type" ] = config.data instanceof FormData ? undefined : "application/json";

    const method = config.method?.toUpperCase();
    const requiresCSRF = config.requiresCSRF ?? [ "PUT", "DELETE" ].includes(method ?? "");

    if (requiresCSRF)
    {
        const module = getCSRFModule(config.baseURL + '/' + config.url);
        if (module)
        {
            const csrfTokenObj = await fetchCSRFToken(module);
            if (csrfTokenObj)
            {
                config.headers[ "X-CSRF-Token" ] = csrfTokenObj.data[ "X-CSRF-TOKEN" ];
                config.headers[ "sessionId" ] = csrfTokenObj.data[ "sessionId" ];
            }
        }
    }

    return config;
};

const requestInterceptorNoAccessToken = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig =>
{
console.log("requestInterceptorNoAccessToken config", config);

    config.headers[ 'Accept' ] = '*/*';


    // Check if the data is FormData
    if (config.data instanceof FormData)
    {
        delete config.headers[ 'Content-Type' ];
    } else
    {
        config.headers[ 'Content-Type' ] = 'application/json';
    }

    return config;
};
const responseInterceptor = (config: AxiosResponse): AxiosResponse =>
{
    return config;
};
const errorInterceptor = (error: AxiosError): Promise<AxiosError | AxiosResponse> =>
{
    return getMockData(error);

    // return Promise.reject(error);
};


export const createAsionInstance = (axiosObject: CreateAxiosDefaults): AxiosInstance =>
{
    const p = axios.create({ ...axiosObject, withCredentials: true });
    p?.interceptors.request.use(requestInterceptor, errorInterceptor);
    p?.interceptors.response.use(responseInterceptor, errorInterceptor);
    return p;
};


// axios.get(HOME_BASE_URL + url, {
//     headers: { 'Content-Type': 'application/json', },
//     //@ts-ignore
//     referrerPolicy: 'no-referrer-when-downgrade', // Optional, if you need to override the default 
//     policywithCredentials: true, // Only if cookies or authentication tokens are needed 
// })
export const createAsionInstanceNoAccesstoken = (axiosObject: CreateAxiosDefaults): AxiosInstance =>
{
    const p = axios.create({ ...axiosObject, withCredentials: true });
    p?.interceptors.request.use(requestInterceptorNoAccessToken, errorInterceptor);
    p?.interceptors.response.use(responseInterceptor, errorInterceptor);
    return p;
};